import * as api from './../../http'

export const ActionSetUtils = async ({ commit }) => {
  const utils = await api.http.get('dash/dp/utils').then((response) => response.body)
  commit('SET_utils', utils)
}

export const ActionSetStates = async ({ commit }) => {
  const states = await api.http.get('dash/utils/states').then((response) => response.body)
  commit('SET_states', states)
}

export const setCurrentCitiesByState = async ({ commit }, selectedState) => {
  const cities = await api.http
    .get('dash/utils/cities/' + selectedState)
    .then((response) => response.body.cities)
  commit('SET_cities', cities)
}

export const ActionSetAuthorizations = async ({ commit }) => {
  const authorizations = await api.http
    .get('dash/utils/authorizations')
    .then((response) => response.body)
  commit('SET_authorizations', authorizations)
}

export const ActionSetPermissions = async ({ commit }) => {
  const permissions = await api.http.get('dash/utils/permissions').then((response) => response.body)
  commit('SET_permissions', permissions)
}

export const ActionSetStatus = async ({ commit }) => {
  const status = await api.http.get('dash/utils/status').then((response) => response.body)
  commit('SET_status', status)
}
export const ActionSetEmployeesDepartments = async ({ commit }) => {
  const departments = await api.http
    .get('dash/utils/employee_departments')
    .then((response) => response.body)
  commit('SET_employeesDepartments', departments)
}

export const ActionSetEmployeesFunctions = async ({ commit }) => {
  const employeeFunction = await api.http
    .get('dash/utils/employee_funcions')
    .then((response) => response.body)
  commit('SET_employeesFunctions', employeeFunction)
}

export const ActionEmployeesRoles = async ({ commit }) => {
  const roles = await api.http.get('dash/utils/employee_roles').then((response) => response.body)
  commit('SET_employeesRoles', roles)
}

export const ActionMaritalStatus = async ({ commit }) => {
  const maritalStatus = await api.http
    .get('dash/utils/marital_status')
    .then((response) => response.body)
  commit('SET_maritalStatus', maritalStatus)
}

export const ActionGenders = async ({ commit }) => {
  const genders = await api.http.get('dash/utils/genders').then((response) => response.body)
  commit('SET_genders', genders)
}

export const ActionSetMonthOfTheYear = async ({ commit }) => {
  const months = await api.http
    .get('dash/utils/months_of_the_year')
    .then((response) => response.body)
  commit('SET_monthsOfTheYear', months)
}

export const ActionSetAdminDepartment = async ({ commit }, payload) => {
  const department = await api.http
    .post('dash/dp/admin/departments', payload)
    .then((response) => response.body)
  commit('SET_departments', department)
}

export const ActionUpdateAdminDepartment = async ({ commit }, payload) => {
  const { id, department } = payload
  const data = { department }
  const departments = await api.http
    .put(`dash/dp/admin/departments/${id}`, data)
    .then((response) => response.body)
  commit('SET_departments', departments)
}

export const ActionStoreWorkstation = async ({ commit }, payload) => {
  const workstations = await api.http
    .post('dash/dp/admin/workstations', payload)
    .then((response) => response.body)
  commit('SET_workstations', workstations)
}

export const ActionUpdateWorkstation = async ({ commit }, payload) => {
  const { id, workstation } = payload
  const data = { workstation }
  const workstations = await api.http
    .put(`dash/dp/admin/workstations/${id}`, data)
    .then((response) => response.body)
  commit('SET_workstations', workstations)
}

//jefferson
export const ActionStoreRoles = async ({ commit }, payload) => {
  const roles = await api.http
    .post('dash/dp/admin/roles', payload)
    .then((response) => response.body)
  commit('SET_roles', roles)
}

export const ActionUpdateRoles = async ({ commit }, payload) => {
  const { id, role } = payload
  const data = { role }
  const roles = await api.http
    .put(`dash/dp/admin/roles/${id}`, data)
    .then((response) => response.body)
  commit('SET_roles', roles)
}

export const ActionStoreFunction = async ({ commit }, payload) => {
  const functions = await api.http
    .post('dash/dp/admin/functions', payload)
    .then((response) => response.body)
  commit('SET_functions', functions)
}

export const ActionUpdateFunction = async ({ commit }, payload) => {
  const { id, functions } = payload
  const data = { functions }
  const user_functions = await api.http
    .put(`dash/dp/admin/functions/${id}`, data)
    .then((response) => response.body)
  commit('SET_functions', user_functions)
}
export const ActionStoreScale = async ({ commit }, payload) => {
  const scales = await api.http
    .post('dash/dp/admin/scale_types', payload)
    .then((response) => response.body)
  commit('SET_scale_types', scales)
}

export const ActionUpdateScale = async ({ commit }, payload) => {
  const { id, ...data } = payload
  const scales = await api.http
    .put(`dash/dp/admin/scale_types/${id}`, data)
    .then((response) => response.body)
  commit('SET_scale_types', scales)
}
